/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Risk_External_Side_EffectInputs */



/**
* | output |
* | --- |
* | "External" |
*
* @param {Rights_Tools_Risk_External_Side_EffectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_risk_external_side_effect = /** @type {((inputs?: Rights_Tools_Risk_External_Side_EffectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Risk_External_Side_EffectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Extern")
	return /** @type {LocalizedString} */ ("External")
});